import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing.space16,
  },
  text: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space4,
  },
  control: {
    flexShrink: 0,
  },
}));
